module.exports = __webpack_public_path__ + "static/media/views.8a1096ff.svg";